import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import { FormModal } from '../../../../components/modal/FormModal';
import { useModalToggle } from '../../../../components/modal/Modal';
import { TableButton } from '../../../../components/style/ButtonStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { OUTDOOR_GYM_EQUIPMENT_ID } from '../../../../utils/enum';

export default function EditCategoryButton({
  label,
  form,
  children,
  category,
  categoryId,
  getResult,
}: any) {
  const { on, open, close } = useModalToggle();
  const onCloseModal = () => {
    close();
    form.reset();
  };
  const [putCategoryResult, putCategory] = useAuthAxios({
    method: 'PUT',
    url: `/api/v1/${category}/${categoryId}`,
  });
  const onSubmitEditForm = form.handleSubmit(function (values: any) {
    if (category === 'inspectionResultType') {
      const payload = {
        title: values.title,
        notes: values.notes,
      };
      putCategory({ data: payload });
    } else if (category === 'department') {
      const payload = {
        title: values.title,
        description: values.description,
      };
      putCategory({ data: payload });
    } else if (category === 'category') {
      const data = new FormData();
      data.append('categoryType', values.categoryType);
      data.append('title', values.title);
      data.append('notes', values.notes);
      data.append('file', values.file);

      putCategory({ data });
    } else if (category === 'subcategory') {
      const payload = {
        title: values.title,
        subCategoryType: values.subCategoryType,
        notes: values.notes,
        categoryId: OUTDOOR_GYM_EQUIPMENT_ID,
      };
      putCategory({ data: payload });
    }
  });
  return (
    <>
      <TableButton onClick={open}>수정</TableButton>
      <FormModal
        on={on}
        onClose={onCloseModal}
        title={label}
        children={children}
        onConfirm={onSubmitEditForm}
      />
      <ApiResultModal
        apiResult={putCategoryResult}
        successTitle="수정됐습니다."
        successCode={200}
        onSuccessClose={() => {
          onCloseModal();
          getResult();
        }}
        failTitle="관리자에게 문의해주세요."
        ErrorCodeTable={{
          PAYLOAD_INVALID: { title: '입력값을 확인해주세요' },
        }}
      />
    </>
  );
}
